<template>

    <el-button id="save-drafts"
               @click="saveDraftsDialogVisible = true"
               plain
               type="warning">
            {{$t('saveAllDrafts.saveAllDraftsButton')}}
        <div class="bttn-img">
            <span class="material-symbols-outlined">
                add_comment
            </span>
        </div>
    </el-button>

    <el-dialog v-model="saveDraftsDialogVisible"
               :title="$t('saveAllDrafts.saveAllDraftsPopup')"
               width="30%"
               align-center>
        <div class="message" v-html="$t('saveAllDrafts.saveDrftsMessageHtml')"></div>

        <el-collapse v-model="activeCollapse"
                     @change="onCollapseChange"
                     class="include-edited">
            <el-collapse-item name="includeEdited"
                              :title="$t('saveAllDrafts.includeEditedTitle')">
                <div class="reason" v-html="$t('saveAllDrafts.includeEditedReason')"></div>
                <el-checkbox v-model="includeEdited">
                    {{$t('saveAllDrafts.includeEdited')}}
                </el-checkbox>
            </el-collapse-item>
        </el-collapse>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closeSaveDraftsDialog">
                    {{$t('generic.cancel')}}
                </el-button>
                <el-button type="primary" @click="saveAllDrafts">
                    {{$t('generic.confirm')}}
                </el-button>
            </span>
        </template>
    </el-dialog>

</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        emits: ['saveConfirmed'],
        data() {
            return {
                saveDraftsDialogVisible: false,
                includeEdited: false,
                activeCollapse: [] as string[],
            }
        },
        methods: {
            saveAllDrafts() {
                this.$emit('saveConfirmed', this.includeEdited);
                this.closeSaveDraftsDialog();
            },
            onCollapseChange(active: string[]) {
                // Keep the section open while the user has opted in,
                // so an active checkbox can't be hidden by collapsing.
                if (this.includeEdited && !active.includes('includeEdited')) {
                    this.activeCollapse = ['includeEdited'];
                }
            },
            closeSaveDraftsDialog() {
                this.saveDraftsDialogVisible = false;
                this.includeEdited = false;
                this.activeCollapse = [];
            },
        }
    })
</script>

<style lang="scss" scoped>
    .bttn-img {
        margin-left: 10px;
    }

    .message {
        font-size: 1.1em;
    }

    .include-edited {
        margin-top: 8px;
    }

    .reason {
        margin-bottom: 8px;
    }
</style>
